import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import Video from 'routes/Products/components/Video';
import * as styles from 'styles/index.scss';

const { landingContainer } = styles;

class Landing extends PureComponent {
  constructor(props) {
    super(props);

    this.Children = {};
    props.Children &&
      props.Children.map(child => {
        this.Children[`${child.type}`] = child;
      });

    // console.log('this.Children in course: ', this.Children);
  }

  render() {
    if (this.props.data) {
      const {
        title,
        data: {
          optInText,
          smsText,
          details,
          eventDetails
          // description,
        }
      } = this.props;
    }
    const {
      // daysList,
      video
    } = this.Children;

    return this.props.data ? (
      <div className={landingContainer}>
        <div>
          <h1>{title}</h1>
        </div>

        {video ? <Video save {...video} /> : null}

        <div>
          <span>Details: {details} </span>
        </div>

        <div>
          <Button>{smsText}</Button>
        </div>
      </div>
    ) : (
      <>
        <div>
          <h2>Oops! We couldn’t find this product in your account.</h2>

          <p>This usually means one of two things:</p>
          <ol>
            <li> You may not own this program or course under this account.</li>
            <li>You might be logged in under a different email address than the one you used to purchase.</li>
          </ol>
          <br />
          <h4>Next steps:</h4>
          <ul>
            <li>
              Try clicking the <b>“My Products”</b> button to see if it's listed there.
            </li>
            <li>
              If not, please <b>log out and log back in</b> using the email address you used at checkout.
            </li>
            <li>
              Still having trouble? Contact at us at{' '}
              <a href="mailto:support@foodrevolution.org">support@foodrevolution.org</a> and we’ll be happy to help!
            </li>
          </ul>
        </div>
      </>
    );
  }
}

Landing.propTypes = {
  Children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.shape({}).isRequired,
  title: PropTypes.string.isRequired
};

export default Landing;
